import { Question } from './question';
import { TaxPolicy } from './tax-policy';

export class SecurityQuestionAnswer {
  securityQuestionAnswerId!: number;
  taxPolicyId!: number;
  taxRuleId!: number;
  questionId!: number;
  securityId!: number;
  text!: string;
  comment!: null;
  isActive!: boolean;
  created!: Date;
  createdBy!: string;
  modified!: Date;
  modifiedBy!: string;
  question!: Question;
  security!: null;
  taxPolicy!: TaxPolicy | null;
  taxRule!: null;
  unsureAnswer!: boolean;
}
